import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { ArticleStatus } from '../../../enums/article-status';
import Sector from '../../../enums/sector';
import RadioGroup from '../../../components/form/elements/radio-group';
import Text from '../../../components/form/elements/text';
import TextArea from '../../../components/form/elements/text-area';
import Readonly from '../../../components/form/elements/readonly';
import Select from '../../../components/form/elements/select';
import Wysiwyg from '../../../components/form/elements/wysiwyg';

export default function useArticleForm(mode = 'view') {
  const { t } = useTranslation();

  const initialState =
    mode === 'create'
      ? []
      : [
          Readonly(
            Text('created_at', 'pages.internal.articles.table.created_at')
          ),
        ];

  initialState.push(
    Select('category', {
      options: [
        {
          value: Sector.CROP,
          label: t(`classifiers.properties.sector.${Sector.CROP}`),
        },
        {
          value: Sector.LIVESTOCK,
          label: t(`classifiers.properties.sector.${Sector.LIVESTOCK}`),
        },
      ],
      multi: true,
      label: 'pages.internal.articles.table.category',
    }),
    RadioGroup(
      'status',
      [
        {
          value: ArticleStatus.PUBLIC,
          label: t(`pages.internal.articles.status.${ArticleStatus.PUBLIC}`),
        },
        {
          value: ArticleStatus.INTERNAL,
          label: t(`pages.internal.articles.status.${ArticleStatus.INTERNAL}`),
        },
      ],
      'pages.internal.articles.table.status'
    ),
    Text('title', 'pages.internal.articles.table.title'),
    TextArea('description', 'pages.internal.articles.table.description'),
    Wysiwyg('content', 'pages.internal.articles.table.content')
  );

  const [form] = useState(initialState);
  return form;
}

export const articleSchema = yup.object().shape({
  category: yup
    .array()
    .required()
    .of(yup.string().required().oneOf([Sector.CROP, Sector.LIVESTOCK]))
    .min(1),
  status: yup
    .string()
    .required()
    .oneOf([ArticleStatus.PUBLIC, ArticleStatus.INTERNAL]),
  title: yup.string().max(255).required(),
  description: yup.string().max(255).required(),
  content: yup.string().required(),
});
